import type { RefObject } from 'react';

export const getColumnWidths = (carouselRef: RefObject<HTMLDivElement>) => {
  const columns = carouselRef.current?.childNodes || [];
  const columnWidths = Array.from(Array(columns.length).fill(0));

  columns.forEach((column, i) => {
    const { width } = (column as Element).getBoundingClientRect();

    if (width > columnWidths[i]) {
      columnWidths[i] = width;
    }
  });

  return columnWidths;
};
